export const USER_ROLES = {
  billing: {
    id: 'billing',
    label: {
      long: 'label.BILLING_ADMIN',
      short: 'label.BILLING'
    },
    color: 'var(--color-orange-200)'
  },
  domainadmin: {
    id: 'domainadmin',
    label: {
      long: 'label.DOMAIN_ADMIN',
      short: 'label.DOMAIN'
    },
    color: 'var(--color-green-200)'
  },
  marketing: {
    id: 'marketing',
    label: {
      long: 'label.MARKETING_ADMIN',
      short: 'label.MARKETING'
    },
    color: 'var(--color-red-200)'
  },
  signatures: {
    id: 'signatures',
    label: {
      long: 'label.SIGNATURE_ADMIN',
      short: 'label.SIGNATURE'
    },
    color: 'var(--color-blue-200)'
  },
  user: {
    id: 'user',
    label: {
      long: 'label.USER',
      short: 'label.USER'
    },
    color: 'var(--color-gray-200)'
  },
  viewonly: {
    id: 'viewonly',
    label: {
      long: 'label.READ_ONLY',
      short: 'label.READ_ONLY'
    },
    color: 'var(--color-gray-800)',
    // Not a role of its own: mailapi only reads it to strip writes from
    // signatures/marketing admins, so it is surfaced as a switch, not an option.
    modifier: true
  }
};
